/* GENERATED by tools/sync-price-book.mjs from assets/mad-price-book.json. Do not edit; edit the JSON and re-run. */
window.MAD_PRICE_BOOK = {
  "_comment": "Service prices approved by Seth: D7 (2026-09-24) raised wax to 395 per product (a single and a pair listing are each one product) and kept every other service price. Replacement glass: Seth, 2026-09-25 (answer 8), Eric prices it by hand on each quote and the site never shows a glass price or rate; glass_clear_tempered and glass_per_sqft (D13 of 2026-09-24, pricing by pane size, now dormant) stay only because the deployed version 1 Zap and the dormant per-pane path read them. Fit allowances, the finished-opening clearance and the close band are still placeholders (FOR APPROVAL). Edit ONLY this file, then run `node tools/sync-price-book.mjs`: it rewrites assets/mad-price-book.js (what the storefront loads) and tools/zapier_code_step.synced.js (the Zap reference copy). `node --test tests/unit` proves the copies agree. Bump `version` on every price change so Eric can spot a stale Zap on the draft order, and change the Zap PRICES block in the same hour.",
  "version": "2026-09-25-d7-d13",
  "currency": "USD",
  "prices": {
    "resize_yes": 425,
    "resize_trim": 199,
    "resize_add": 299,
    "resize_both": 399,
    "restore_remove_hardware": 79,
    "restore_square_edges": 99,
    "restore_patch_mortise": 79,
    "restore_fix_cracks": 79,
    "restore_light_sand": 99,
    "restore_heavy_sand": 199,
    "restore_full": 999,
    "wax_finish": 395,
    "glass_remove": 79,
    "glass_clear_tempered": 499,
    "glass_per_sqft": 40,
    "prehang_single_base": 599,
    "prehang_pair_base": 699,
    "prehang_cypress_add": 29,
    "prehang_wide_jamb_add": 50,
    "prehang_arched_multiplier": 1.647,
    "prehang_exterior_upcharge": 300,
    "prehang_magnetic_latch": 0,
    "join_pair_as_single": 395,
    "freight_curbside_ltl": 499
  },
  "restoration_tiers": {
    "_comment": "Tiers are sums of the item prices above until Seth sets bundle prices. Each tier expands into the restore_* keys listed, set to '1' inside _raw, so the Zap prices them line by line exactly as today. Tier 2 includes Tier 1.",
    "none": {
      "label": "None, as-is",
      "keys": []
    },
    "tier1": {
      "label": "Tier 1: hardware off, edges squared, holes patched",
      "keys": [
        "restore_remove_hardware",
        "restore_square_edges",
        "restore_patch_mortise"
      ]
    },
    "tier2_light": {
      "label": "Tier 2 light: Tier 1 plus crack repair and light sanding (keeps the patina)",
      "keys": [
        "restore_remove_hardware",
        "restore_square_edges",
        "restore_patch_mortise",
        "restore_fix_cracks",
        "restore_light_sand"
      ]
    },
    "tier2_heavy": {
      "label": "Tier 2 heavy: Tier 1 plus crack repair and heavy sanding (removes color)",
      "keys": [
        "restore_remove_hardware",
        "restore_square_edges",
        "restore_patch_mortise",
        "restore_fix_cracks",
        "restore_heavy_sand"
      ]
    },
    "full": {
      "label": "Full restoration: everything",
      "keys": [
        "restore_full"
      ]
    }
  },
  "fit": {
    "_comment": "Inches. rough_clearance is how much bigger than the slab a rough opening is: D3a (2026-09-24) about 3 inches wider and taller than the door. finished_clearance is the same for a finished opening between jamb faces (placeholder, FOR APPROVAL). close_band is the tolerance around that ideal that still reads as a close match (placeholder, FOR APPROVAL). trim_allowance and add_allowance are how far a door can be cut down or built up per door type before the readout says talk to us (placeholders until Seth supplies per-type allowances). The arched rule (Seth 2026-10-13: an arched door is trimmed or built up in height like a square door, its width is never changed) and the iron rule (built as one piece, no trim) are categorical. listed_tolerance and serviced_tolerance are D3b: listed sizes are accurate to about 1/2 inch; doors Magnolia resizes or frames come out within about 1/8 inch.",
    "rough_clearance": {
      "width": 3,
      "height": 3
    },
    "finished_clearance": {
      "width": 0.25,
      "height": 0.75
    },
    "close_band": 1,
    "trim_allowance": {
      "solid": 4,
      "glass": 2,
      "iron": 0
    },
    "add_allowance": {
      "solid": 4,
      "glass": 4,
      "iron": 0
    },
    "arched_width_fixed": true,
    "listed_tolerance": 0.5,
    "serviced_tolerance": 0.125
  },
  "glass": {
    "_comment": "Three replacement glass types (clear tempered, diamond pattern, English pattern) plus keep or remove. Seth, 2026-09-25 (answer 8): replacement glass is priced by hand by Eric on each quote; the site shows every replacement type as priced on your quote and adds nothing, and Zap version 2 carries the choice to Eric without a price. Removal keeps its flat glass_remove price. Whether the patterned glass is tempered is OPEN (FOR APPROVAL), so the site asks for the safety acknowledgment on patterned glass too. The pane limits below are read only by the dormant per-pane path (zap_supports.glass_by_pane, which stays false).",
    "replacement_types": [
      "clear_tempered",
      "diamond_pattern",
      "english_pattern"
    ],
    "tempered": {
      "clear_tempered": true,
      "diamond_pattern": null,
      "english_pattern": null
    },
    "max_panes": 60,
    "max_pane_inches": 120
  },
  "freight": {
    "_comment": "D8 (2026-09-24): show the typical range before checkout, exact for the ZIP on the estimate or at checkout. Display only: the Zap still adds its freight_curbside_ltl line and Eric re-prices.",
    "typical_low": 350,
    "typical_high": 650,
    "typical_max_doors": 2
  },
  "trade": {
    "_comment": "Seth, 2026-09-25 (answer 7, replaces D6 'applied automatically'): an approved trade account (Shopify customer tag trade) earns 10% store credit on its first order (Shopify Flow, when that order is paid) and gets door_rate off the doors only on every order after that; services and freight at full price. Nobody gets it automatically until accounts are tagged. The site never shows a discounted total while zap_supports.trade_discount is false; a ticked checkbox is a request Eric verifies.",
    "door_rate": 0.1,
    "customer_tag": "trade"
  },
  "zap_supports": {
    "_comment": "Launch gate (review of 2026-09-25): what the Zap can bill. glass_by_pane false (and it stays false, answer 8): every replacement glass shows as priced on your quote (0 on the site and on the draft), and no glass_panes key is written. trade_discount false: a logged-in trade account is told its trade pricing is confirmed on the quote, with no discounted total (the site cannot tell a first order, which earns store credit, from a later one). Flip a flag to true ONLY in the same commit (and the same hour) as the Zap paste that bills it, bump version at the same time, and run node tools/sync-price-book.mjs.",
    "glass_by_pane": false,
    "trade_discount": false
  },
  "install_ready": {
    "_comment": "The Install Ready (pre-hung) bundle is priced from the prehang_* keys above. A Tri-Fold set has no rule of its own yet and is priced as a single jamb, the same as the Zap today (placeholder until Seth sets one).",
    "default_wall_depth": "4_9_16",
    "default_interior_grade": "prime_pine",
    "exterior_grade": "stain_cypress"
  }
};
